/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MetricEventProperties,
    MetricEventPropertiesFromJSON,
    MetricEventPropertiesFromJSONTyped,
    MetricEventPropertiesToJSON,
    SubMetric,
    SubMetricFromJSON,
    SubMetricFromJSONTyped,
    SubMetricToJSON,
} from './';

/**
 * 
 * @export
 * @interface Metric
 */
export interface Metric {
    /**
     * The ID for the Event to select data from. Omitted for global metrics that are not relative to a specific Event, i.e. \"overall revenue\"
     * @type {number}
     * @memberof Metric
     */
    event_id?: number;
    /**
     * 
     * @type {string}
     * @memberof Metric
     */
    event_type?: string;
    /**
     * An optional title for the unique metric configuration. If not provided, the event name will be used.
     * @type {string}
     * @memberof Metric
     */
    display_title?: string;
    /**
     * An optional name for the unit of the unique metric configuration.
     * @type {string}
     * @memberof Metric
     */
    display_unit?: string;
    /**
     * The aggregation function for the numerator of the metric. \'unique\' measures the number of unique visitors/sessions that include the specified Event. \'count\' measures the total number of occurrences of Event for the scope (visitor/session). \'sum\' is the sum of the \'field\' value
     * @type {string}
     * @memberof Metric
     */
    aggregator: MetricAggregatorEnum;
    /**
     * The field to aggregate for the numerator of the metric. Required when \'aggregator\' = \'sum\', otherwise omitted
     * @type {string}
     * @memberof Metric
     */
    field?: MetricFieldEnum;
    /**
     * Specifies how Events should be grouped together. Can also be thought of as the denonimator of the metric. \'session\' divides by the number of sessions. \"Influenced sessions\", or sessions that do not contain a decision Event but carry a decision from a previous session are not included in counts for numerator or denominator. \'visitor\' divides by the number of visitors. \'event\' divides by the total occurrences (impressions) of the specified Event
     * @type {string}
     * @memberof Metric
     */
    scope?: MetricScopeEnum;
    /**
     * The winning direction of this metric
     * @type {string}
     * @memberof Metric
     */
    winning_direction: MetricWinningDirectionEnum;
    /**
     * 
     * @type {MetricEventProperties}
     * @memberof Metric
     */
    event_properties?: MetricEventProperties;
    /**
     * 
     * @type {Array<SubMetric>}
     * @memberof Metric
     */
    metrics?: Array<SubMetric>;
}

export function MetricFromJSON(json: any): Metric {
    return MetricFromJSONTyped(json, false);
}

export function MetricFromJSONTyped(json: any, ignoreDiscriminator: boolean): Metric {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event_id': !exists(json, 'event_id') ? undefined : json['event_id'],
        'event_type': !exists(json, 'event_type') ? undefined : json['event_type'],
        'display_title': !exists(json, 'display_title') ? undefined : json['display_title'],
        'display_unit': !exists(json, 'display_unit') ? undefined : json['display_unit'],
        'aggregator': json['aggregator'],
        'field': !exists(json, 'field') ? undefined : json['field'],
        'scope': !exists(json, 'scope') ? undefined : json['scope'],
        'winning_direction': json['winning_direction'],
        'event_properties': !exists(json, 'event_properties') ? undefined : MetricEventPropertiesFromJSON(json['event_properties']),
        'metrics': !exists(json, 'metrics') ? undefined : ((json['metrics'] as Array<any>).map(SubMetricFromJSON)),
    };
}

export function MetricToJSON(value?: Metric | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event_id': value.event_id,
        'event_type': value.event_type,
        'display_title': value.display_title,
        'display_unit': value.display_unit,
        'aggregator': value.aggregator,
        'field': value.field,
        'scope': value.scope,
        'winning_direction': value.winning_direction,
        'event_properties': MetricEventPropertiesToJSON(value.event_properties),
        'metrics': value.metrics === undefined ? undefined : ((value.metrics as Array<any>).map(SubMetricToJSON)),
    };
}

/**
* @export
* @enum {string}
*/
export enum MetricAggregatorEnum {
    Unique = 'unique',
    Count = 'count',
    Sum = 'sum',
    Ratio = 'ratio'
}
/**
* @export
* @enum {string}
*/
export enum MetricFieldEnum {
    Revenue = 'revenue',
    Value = 'value'
}
/**
* @export
* @enum {string}
*/
export enum MetricScopeEnum {
    Session = 'session',
    Visitor = 'visitor',
    Event = 'event'
}
/**
* @export
* @enum {string}
*/
export enum MetricWinningDirectionEnum {
    Increasing = 'increasing',
    Decreasing = 'decreasing'
}


